import { FC, useMemo } from 'react';

import { DateTime } from 'luxon';
import { PaymentItem as PaymentItemModel } from 'store/my-registrations/types';

import { Divider } from '@britishcouncil/react-solas-ors3';

import { PaymentItem } from './PaymentItem';

export const PaymentsList: FC<{ payments: PaymentItemModel[] }> = ({ payments }) => {
  const paymentGroups = useMemo(
    () =>
      [...payments]
        .sort((x, y) => DateTime.fromISO(x.transactionDate).diff(DateTime.fromISO(y.transactionDate)).toMillis())
        .reduce((groups, item) => {
          let existingGroup = groups.find((g) => g.reference === item.reference);
          if (existingGroup) {
            existingGroup.payments.push(item);
          } else {
            groups.push({ reference: item.reference, paymentSlipNumber: item.paymentSlipNumber, payments: [item] });
          }
          return groups;
        }, [] as { reference: string; paymentSlipNumber: string | null; payments: PaymentItemModel[] }[]) ?? [],
    [payments]
  );

  return (
    <>
      {paymentGroups.map((group, i) => (
        <div key={i}>
          <h3>Reference number: {group.paymentSlipNumber ?? group.reference}</h3>
          {group.payments.map((payment, j) => (
            <PaymentItem payment={payment} key={j} />
          ))}
          <Divider />
        </div>
      ))}
    </>
  );
};
